var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/26d09982f4e06a203d4e8edc9e8a5201.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d66e0cb83b4d8e2e6e93119c2d52d3ef.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    